import { useEffect, useMemo, useRef, useState } from "react";
import clsx from "clsx";
import {
  // motion,
  // useAnimationFrame,
  useInView,
  // useMotionValue,
  // useSpring,
  // useTransform,
} from "framer-motion";

import { Container } from "../Container";
import { siteSettings } from "../../settings";

const reviews = [
  {
    title: "Incredible company",
    body: "Incredible company, I've been trading for a while with them, had two quick withdrawals and fee refund in less than 48 hours. I absolutely recommend the firm",
    author: "Louis can Nuekerk",
    rating: 5,
    role: "Professional trader",
    image:
      "https://user-images.trustpilot.com/58c446dd0000ff000a808de2/73x73.png",
  },
  {
    title: "Amazing platform",
    body: "This is an amazing platform which gives you opportunity to achieve their goals and become successful traders with the support of finances.",
    author: "Adam",
    rating: 5,
    role: "User",
    image:
      " https://user-images.trustpilot.com/5cac659ab628b746a119fd61/73x73.png",
  },
  {
    title: "Highly recommended",
    body: "Great company, no issues with payouts, great customer support. Highly recommended for experienced traders.",
    author: "Jakub Szulc",
    rating: 5,
    role: "Trader",
    image:
      "https://user-images.trustpilot.com/5fd721e2c4a9b800196081bd/73x73.png",
  },
  {
    title: "great",
    body: "legitimate! thank you for the opportunity, nothing out there can compare",
    author: "Dee",
    rating: 4,
    role: "Review expert",
    image:
      "https://user-images.trustpilot.com/6321c934f2a8b90013faaf15/73x73.png",
  },
  {
    title: "Excellent platform",
    body: `${siteSettings.name} has everything you can ask for, I'm super happy it has been recommended to me as my first broker`,
    author: "Agata Vincent",
    rating: 5,
    role: "Trader",
    image:
      "https://user-images.trustpilot.com/64a712e728582c0011a9260e/73x73.png",
  },
  {
    title: "Really good experience",
    body: "Amazing experience. I have a very nice experience using this platform. Execution speed is one of the best all over the market.",
    author: "Pro Kittisak",
    rating: 4,
    role: "User",
    image:
      "https://user-images.trustpilot.com/64c13a9a79f4110012303256/73x73.png",
  },
];

function StarIcon(props) {
  return (
    <svg viewBox="0 0 20 20" aria-hidden="true" {...props}>
      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
    </svg>
  );
}

function StarRating({ rating }) {
  return (
    <div className="flex">
      {[...Array(5).keys()].map((index) => (
        <StarIcon
          key={index}
          className={clsx(
            "h-5 w-5",
            rating > index ? "fill-cyan-500" : "fill-gray-300"
          )}
        />
      ))}
    </div>
  );
}

function Review({
  title,
  body,
  author,
  rating,
  role,
  image,
  className,
  ...props
}) {
  let animationDelay = useMemo(() => {
    let possibleAnimationDelays = [
      "0s",
      "0.1s",
      "0.2s",
      "0.3s",
      "0.4s",
      "0.5s",
    ];
    return possibleAnimationDelays[
      Math.floor(Math.random() * possibleAnimationDelays.length)
    ];
  }, []);

  return (
    <figure
      className={clsx(
        "animate-fade-in rounded-3xl bg-white p-6 opacity-0 shadow-md shadow-gray-900/5",
        className
      )}
      style={{ animationDelay }}
      {...props}
    >
      <blockquote className="text-gray-900">
        <StarRating rating={rating} />
        <p className="mt-4 text-lg font-semibold leading-6 before:content-['“'] after:content-['”']">
          {title}
        </p>
        <p className="mt-3 text-base leading-7">{body}</p>
      </blockquote>
      <figcaption className="relative mt-6 flex items-center justify-between border-t border-slate-100 pt-6">
        <div>
          <div className="font-display text-base text-slate-900">{author}</div>
          <div className="mt-1 text-sm text-slate-500">{role}</div>
        </div>
        <div className="overflow-hidden rounded-full bg-slate-50">
          <img
            className="h-14 w-14 object-cover"
            src={image}
            alt=""
            width={56}
            height={56}
          />
        </div>
      </figcaption>
      {/* <figcaption className="mt-3 text-sm text-gray-600 before:content-['–_']">
        {author}
      </figcaption> */}
    </figure>
  );
}

function splitArray(array, numParts) {
  let result = [];
  for (let i = 0; i < array.length; i++) {
    let index = i % numParts;
    if (!result[index]) {
      result[index] = [];
    }
    result[index].push(array[i]);
  }
  return result;
}

function ReviewColumn({
  className,
  reviews,
  reviewClassName = () => {},
  msPerPixel = 0,
}) {
  let columnRef = useRef();
  let [columnHeight, setColumnHeight] = useState(0);
  let duration = `${columnHeight * msPerPixel}ms`;

  useEffect(() => {
    let resizeObserver = new window.ResizeObserver(() => {
      setColumnHeight(columnRef.current.offsetHeight);
    });

    resizeObserver.observe(columnRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div
      ref={columnRef}
      className={clsx("animate-marquee space-y-8 py-4", className)}
      style={{ "--marquee-duration": duration }}
    >
      {reviews.concat(reviews).map((review, reviewIndex) => (
        <Review
          key={reviewIndex}
          aria-hidden={reviewIndex >= reviews.length}
          className={reviewClassName(reviewIndex % reviews.length)}
          {...review}
        />
      ))}
    </div>
  );
}

function ReviewGrid() {
  let containerRef = useRef();
  let isInView = useInView(containerRef, { once: true, amount: 0.4 });
  let columns = splitArray(reviews, 3);
  columns = [columns[0], columns[1], splitArray(columns[2], 2)];

  return (
    <div
      ref={containerRef}
      className="relative -mx-4 mt-16 grid h-[49rem] max-h-[150vh] grid-cols-1 items-start gap-8 overflow-hidden px-4 sm:mt-20 md:grid-cols-2 lg:grid-cols-3"
    >
      {isInView && (
        <>
          <ReviewColumn
            reviews={[...columns[0], ...columns[2].flat(), ...columns[1]]}
            reviewClassName={(reviewIndex) =>
              clsx(
                reviewIndex >= columns[0].length + columns[2][0].length &&
                  "md:hidden",
                reviewIndex >= columns[0].length && "lg:hidden"
              )
            }
            msPerPixel={10}
          />
          <ReviewColumn
            reviews={[...columns[1], ...columns[2][1]]}
            className="hidden md:block"
            reviewClassName={(reviewIndex) =>
              reviewIndex >= columns[1].length && "lg:hidden"
            }
            msPerPixel={15}
          />
          <ReviewColumn
            reviews={columns[2].flat()}
            className="hidden lg:block"
            msPerPixel={10}
          />
        </>
      )}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-white" />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-white" />
    </div>
  );
}

export function TestimonialOne() {
  return (
    <section
      id="reviews"
      aria-labelledby="reviews-title"
      className="pb-16 pt-20 sm:pb-24 sm:pt-32 grid"
    >
      <Container className="grid items-center self-center">
        <h2
          id="reviews-title"
          style={{
            placeSelf: "center",
            lineHeight: "58px",
            letterSpacing: "-1.21px",
          }}
          className="text-[45px] font-semibold tracking-tight text-gray-900 sm:text-center max-w-[475px]"
        >
          Built for today’s ambitious earners
        </h2>
        <p
          style={{ placeSelf: "center" }}
          className="mt-2 text-[18px] text-gray-600 sm:text-center max-w-[595px]"
        >
          Thousands of forward-thinking users rely on {siteSettings.name}{" "}
          everyday to turbo-charge their financial operations
        </p>
        <ReviewGrid />
      </Container>
    </section>
  );
}
